import { render } from "./PromptStudio.vue?vue&type=template&id=1824bcc5&scoped=true&ts=true"
import script from "./PromptStudio.vue?vue&type=script&lang=ts"
export * from "./PromptStudio.vue?vue&type=script&lang=ts"

import "./PromptStudio.vue?vue&type=style&index=0&id=1824bcc5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1824bcc5"]])

export default __exports__